import React from "react";
import THEME from "../theme";
import { GlowDot } from "./UIComponents";
import { MIGRATION_SPECIES, MONTH_NAMES } from "../data/migration";

export default function MigrationTimeline() {
  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ display: "grid", gridTemplateColumns: "140px repeat(12, 1fr)", gap: 2, minWidth: 500 }}>
        <div style={{ fontSize: 10, color: THEME.textDim, fontWeight: 700 }}>SPECIES</div>
        {MONTH_NAMES.map((m, i) => (
          <div key={i} style={{ textAlign: "center", fontSize: 10, color: THEME.textDim, fontWeight: 600 }}>{m}</div>
        ))}
        {MIGRATION_SPECIES.map((s) => (
          <React.Fragment key={s.name}>
            <div style={{ fontSize: 11, color: s.color, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
              <GlowDot color={s.color} size={6} />
              {s.name}
            </div>
            {MONTH_NAMES.map((_, mi) => {
              const isActive = s.months.includes(mi);
              const isPeak = s.peak.includes(mi);
              return (
                <div key={mi} style={{ height: 24, borderRadius: 3, background: isPeak ? `${s.color}50` : isActive ? `${s.color}20` : "transparent", border: isActive ? `1px solid ${s.color}40` : "1px solid transparent", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {isPeak && <div style={{ width: 4, height: 4, borderRadius: 2, background: s.color }} />}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
      <div style={{ marginTop: 16, padding: 12, background: THEME.bgPanel, borderRadius: 8, border: `1px solid ${THEME.border}` }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: THEME.accent, marginBottom: 8, letterSpacing: "0.08em" }}>OBSERVED MIGRATION SHIFTS (days/decade)</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          {MIGRATION_SPECIES.map((s) => (
            <div key={s.name} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11 }}>
              <GlowDot color={s.color} size={5} />
              <span style={{ color: THEME.textMuted }}>{s.name}:</span>
              <span style={{ color: s.shift < 0 ? THEME.warning : THEME.danger, fontWeight: 700, fontFamily: "monospace" }}>{s.shift > 0 ? "+" : ""}{s.shift}d</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, fontSize: 10, color: THEME.textDim }}>Source: Kovach et al. 2013 (PLOS ONE), Wilson et al. (Nature CC), Keefer et al. 2008 (TAFS). Negative = earlier migration.</div>
      </div>
    </div>
  );
}
